/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Unit_Per_HandInputs */

const en_us2_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg per dumbbell`)
};

const pt_br2_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg por halter`)
};

const es_419_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg por mancuerna`)
};

const pt_pt2_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg por haltere`)
};

const fr_fr2_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg par haltère`)
};

const de_de2_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg pro Hantel`)
};

const it_it2_workout_logging_unit_per_hand = /** @type {(inputs: Workout_Logging_Unit_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg per manubrio`)
};

/**
* | output |
* | --- |
* | "kg per dumbbell" |
*
* @param {Workout_Logging_Unit_Per_HandInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_unit_per_hand = /** @type {((inputs?: Workout_Logging_Unit_Per_HandInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Unit_Per_HandInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_unit_per_hand(inputs)
	if (locale === "es-419") return es_419_workout_logging_unit_per_hand(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_unit_per_hand(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_unit_per_hand(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_unit_per_hand(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_unit_per_hand(inputs)
	return en_us2_workout_logging_unit_per_hand(inputs)
});
export { workout_logging_unit_per_hand as "workout-logging.unit_per_hand" }